/* eslint-disable no-console */
import { Fragment, useEffect, useMemo } from "react";
import { Modal } from "@storybook";

import { VerifyScreen, VerifiedScreen, VerifyingScreen } from "components";
import {
  AccountDetails,
  SIGNUP_SCREEN,
  SignUpForm,
  SignUpSkelton,
  useSignUp,
} from ".";
import { useInstance, useTranslation } from "hooks";
import { OnboardingFlow } from "shared-component";
import GlobalInstanceManager from "instance-manger";

import "./signup.scss";

// let isLoaded = false;
/**
 * Signup Component
 * Manages the sign-up process with various steps and a modal for verification.
 */
export const Signup = () => {
  // Hook to get translation functions
  const { t } = useTranslation();
  const { instanceDetails, setWebComponentConfig } = useInstance();
  const { webcomponentProps } = GlobalInstanceManager;

  const {
    form,
    currentStep,
    setCurrentStep,
    handleResend,
    currentMethod,
    handleOnCompleteSignUpProcess,
    currentModal,
    setCurrentModal,
  } = useSignUp();

  const {
    VERIFY,
    VERIFYING,
    VERIFIED,
    ACCOUNT_DETAILS,
    ONBOARDING,
    SIGNUP,
    NOTVERIFIED,
  } = SIGNUP_SCREEN;

  /**
   * Determines the properties for the modal based on the current step
   */
  const modalProps = useMemo(() => {
    switch (currentModal) {
      case VERIFY: {
        const {
          isCountryCodeVisible,
          value,
          countryCode = "",
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
        } = form.find((el) => el.name === currentMethod ?? "phone") ?? {};

        return {
          children: (
            <VerifyScreen
              {...t(`signup.verify.${currentMethod ?? "phone"}`)}
              sublabel={
                <>
                  {t(`signup.verify.${currentMethod ?? "phone"}`).sublabel}{" "}
                  <b>{isCountryCodeVisible ? countryCode + value : value}</b>
                </>
              }
              labelClass="text-center"
              sublabelClass="text-center"
              handleResend={handleResend}
            />
          ), // Render VerifyScreen component with translation props
          isOpen: true,
          closeModal: () => setCurrentModal(undefined), // Function to close the modal
          className: "signup-wrapper__signup-modal",
        };
      }
      case VERIFYING:
        return {
          children: (
            <VerifyingScreen
              {...t(`signup.verifying.${currentMethod ?? "phone"}`)}
            />
          ), // Render verifying message
          isOpen: true,
          closeModal: () => setCurrentModal(undefined),
          className: "signup-wrapper__signup-modal",
        };
      case VERIFIED:
        return {
          children: (
            <VerifiedScreen
              {...t(`signup.verified.${currentMethod ?? "phone"}`)}
            />
          ), // Render VerifiedScreen component with translation props
          isOpen: true,
          closeModal: () => setCurrentModal(undefined),
          className: "signup-wrapper__signup-modal",
        };
      case NOTVERIFIED:
        return {
          children: (
            <VerifiedScreen
              {...t(`signup.not-verified.${currentMethod ?? "phone"}`)}
            />
          ), // Render VerifiedScreen component with translation props
          isOpen: true,
          closeModal: () => setCurrentModal(undefined),
          className: "signup-wrapper__signup-modal",
        };

      case ONBOARDING:
        return {
          children: (
            <OnboardingFlow
              onStepChange={(event: any) => {
                GlobalInstanceManager.onStepChangeEvent({
                  event,
                  type: "resend",
                });
              }}
              onComplete={(sessionId: string) => {
                handleOnCompleteSignUpProcess(sessionId);
              }}
              id={instanceDetails.onboardingflow ?? ""}
            />
          ), // Render VerifyScreen component with translation props
          isOpen: true,
          closeModal: () => setCurrentModal(undefined), // Function to close the modal
          className: "signup-wrapper__onboarding-modal",
        };

      default:
        return {
          children: "",
          isOpen: false,
          closeModal: () => setCurrentModal(undefined),
          className: "signup-wrapper__signup-modal",
        };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModal, currentMethod]);


    console.log({currentStep})
  //  useEffect to manage initial loading state
  useEffect(() => {
    //  if (!isLoaded) {
    //     isLoaded = true;
    //     setTimeout(() => {
    //       setCurrentStep(undefined); // Set initial step after loading
    //     }, 1000);
    //   } else {
    //     setCurrentStep(undefined); // Set initial step immediately if already loaded
    //   }
      setWebComponentConfig((prev) => ({
      ...prev,
      iscombinedinput: webcomponentProps.iscombinedinput,
    }));
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Determines which component to render based on the current step
   */
  const renderComponent = useMemo(() => {
    if (currentStep === "loading") {
      return <SignUpSkelton />; // Render skeleton loader during the loading phase
    } else if (currentStep === ACCOUNT_DETAILS) {
      return (
        <AccountDetails
          handleBack={() => setCurrentStep(SIGNUP)} // Handle going back to the sign-up step
          // eslint-disable-next-line no-console
          handleSubmit={() => console.log("submit")} // Placeholder submit handler
        />
      );
    } else {
      return <SignUpForm />; // Render sign-up form by default
    }
  }, [ACCOUNT_DETAILS, SIGNUP, currentStep, setCurrentStep]);

  return (
    <Fragment>
      <div className="signup-wrapper">
        <div className="signup-wrapper__inner content-center">
          {/* Render the component based on the current step */}
          {renderComponent}{" "}
        </div>
      </div>
      {/* Render modal with dynamic props */}
      <Modal {...modalProps} modalName="signup-modal" />{" "}
    </Fragment>
  );
};
